import { RootState } from '@/store/types/RootState';

export const selectPartyDetailsTabListDataRequestsStates = (state: RootState) =>
  state.partyDetailsTabList.dataRequestsStates;

export const selectPartyDetailsInsuredOnList = (state: RootState) => state.partyDetailsTabList.insuredOn;
export const selectPartyDetailsInsuredOnListPagination = (state: RootState) =>
  state.partyDetailsTabList.insuredOn.pagination;
export const selectPartyDetailsInsuredOnListData = (state: RootState) => state.partyDetailsTabList.insuredOn.listings;

export const selectPartyDetailsClaimantOnList = (state: RootState) => state.partyDetailsTabList.claimantOn;
export const selectPartyDetailsClaimantOnListPagination = (state: RootState) =>
  state.partyDetailsTabList.claimantOn.pagination;
export const selectPartyDetailsClaimantOnListData = (state: RootState) => state.partyDetailsTabList.claimantOn.listings;

export const selectPartyDetailsBeneficiaryOnList = (state: RootState) => state.partyDetailsTabList.beneficiaryOn;
export const selectPartyDetailsBeneficiaryOnListPagination = (state: RootState) =>
  state.partyDetailsTabList.beneficiaryOn.pagination;
export const selectPartyDetailsBeneficiaryOnListData = (state: RootState) =>
  state.partyDetailsTabList.beneficiaryOn.listings;

export const selectPartyDetailsIsContactOfList = (state: RootState) => state.partyDetailsTabList.isContactOf;
export const selectPartyDetailsIsContactOfListPagination = (state: RootState) =>
  state.partyDetailsTabList.isContactOf.pagination;
export const selectPartyDetailsIsContactOfListData = (state: RootState) =>
  state.partyDetailsTabList.isContactOf.listings;

export const selectPartyDetailsHasContactOfList = (state: RootState) => state.partyDetailsTabList.hasContactsOf;
export const selectPartyDetailsHasContactOfListPagination = (state: RootState) =>
  state.partyDetailsTabList.hasContactsOf.pagination;
export const selectPartyDetailsHasContactOfListData = (state: RootState) =>
  state.partyDetailsTabList.hasContactsOf.listings;
